export const filterByNameOrId = <
  T extends { name: string | null | undefined; id: string },
>(
  options: T[],
  state: { inputValue: string }
) => {
  return options.filter((option) => {
    const matchesName = option.name
      ?.toLowerCase()
      .includes(state.inputValue.toLowerCase());
    const matchesId = option.id
      .toLowerCase()
      .includes(state.inputValue.toLowerCase());

    if (state.inputValue.length <= 4) {
      return matchesName;
    }
    return matchesName || matchesId;
  });
};
